/**
 *  @file 定义全局方法
 *  @author Dmw
 *  @date 2017-5-24 14:24:32
 *  @description 全局方法统一集中于此，便于查看，使用 Vue.js 开发时全局方法封装入 Vue 的原型中
 */
import Vue from "vue";
// import store from '../../store/index.js';
// import router from '../../router/index.js';
/**
 *  @description 退出登录
 */
// Vue.prototype.$logOut = () => {
//  sessionStorage.username = '';
//   store.commit('token', '');
//   store.commit('setUserInfo', '');
//   router.push('/login');
//   window.location.reload();
// };

Vue.prototype.existCookie = () => {
  console.log(document.cookie);
};
// 设置cookie,增加到vue实例方便全局调用
// vue全局调用的理由是，有些组件所用到的接口可能需要session验证，session从cookie获取
// 当然，如果session保存到vuex的话除外
// Vue.prototype.setCookies = (name, value, expiredays) => {
//   var exdate = new Date();
//   exdate.setDate(exdate.getDate() + expiredays);
//   document.cookie = name + '=' + escape(value) + ((expiredays == null) ? '' : ';expires=' + exdate.toGMTString());
// };

// 获取cookie、
// Vue.prototype.getCookies = (name) => {
//   let arr = new RegExp('(^| )' + name + '=([^;]*)(;|$)');
//   let reg = new RegExp('(^| )' + name + '=([^;]*)(;|$)');
//   if (arr === document.cookie.match(reg)) {
//     return (arr[2]);
//   } else {
//     return null;
//   }
// };
// function getCookies (name) {
//   let arr = new RegExp('(^| )' + name + '=([^;]*)(;|$)');
//   let reg = new RegExp('(^| )' + name + '=([^;]*)(;|$)');
//   if (arr === document.cookie.match(reg)) {
//     return (arr[2]);
//   } else {
//     return null;
//   }
// }
// Vue.prototype.getCookies = getCookies;
// 删除cookie
// Vue.prototype.delCookies = (name) => {
//   var exp = new Date();
//   exp.setTime(exp.getTime() - 1);
//   var cval = this.getCookies(name);
//   if (cval != null) { document.cookie = name + '=' + cval + ';expires=' + exp.toGMTString(); }
// };
// 时间格式化 返回 yyyy-mm-dd hh:mm:ss
Vue.prototype.$timeformat = (now) => {
  if (now === "") return "";
  now = new Date(now);
  // return `${now.getFullYear()}-${now.getMonth() + 1}-${now.getDate()} ${now.getHours()}:${now.getMinutes()}:${now.getSeconds()}`;
  return `${now.getFullYear()}-${
    now.getMonth() + 1 < 10 ? "0" + (now.getMonth() + 1) : now.getMonth() + 1
  }-${now.getDate() < 10 ? "0" + now.getDate() : now.getDate()}   ${
    now.getHours() < 10 ? "0" + now.getHours() : now.getHours()
  }:${now.getMinutes() < 10 ? "0" + now.getMinutes() : now.getMinutes()}:${
    now.getSeconds() < 10 ? "0" + now.getSeconds() : now.getSeconds()
  }`;
};

// yyyy-mm-dd
Vue.prototype.$timeformatDay = (now) => {
  if (now === "") return "";
  now = new Date(now);
  return `${now.getFullYear()}-${
    now.getMonth() + 1 < 10 ? "0" + (now.getMonth() + 1) : now.getMonth() + 1
  }-${now.getDate() < 10 ? "0" + now.getDate() : now.getDate()}`;
};
// yyyy.mm.dd
Vue.prototype.$timeformatDays = (now) => {
  if (now === "") return "";
  now = new Date(now);
  return `${now.getFullYear()}.${
    now.getMonth() + 1 < 10 ? "0" + (now.getMonth() + 1) : now.getMonth() + 1
  }.${now.getDate() < 10 ? "0" + now.getDate() : now.getDate()}`;
};
Vue.prototype.$year = (now) => {
  if (now === "") return "";
  now = new Date(now);
  return `${
    now.getMonth() + 1 < 10 ? "0" + (now.getMonth() + 1) : now.getMonth() + 1
  }-${now.getDate() < 10 ? "0" + now.getDate() : now.getDate()}`;
};
